class LegalGuaranteeModal extends ModalDialog {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }

  hide() {
    const opener = this.openedBy;
    const parentDialog = opener?.closest('cart-drawer.active, modal-dialog[open], quick-add-modal[open]');
    super.hide();

    // Restore the theme's focus trap and scroll lock when returning to an open cart or quick view.
    if (parentDialog) {
      setTimeout(() => {
        if (this.hasAttribute('open') || !opener.isConnected) return;
        if (!parentDialog.classList.contains('active') && !parentDialog.hasAttribute('open')) return;
        document.body.classList.add('overflow-hidden');
        document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
        trapFocus(parentDialog.querySelector('[role="dialog"]'), opener);
      }, 200);
    }
  }
}

customElements.define('legal-guarantee-modal', LegalGuaranteeModal);
